import vi from "locales/vi";
import en from "locales/en";
import type { MessageModule, Messages } from "locales/defineMessages";
import common from "locales/modules/common";
import attendance from "locales/modules/attendance";
import classDetail from "locales/modules/classDetail";
import classForm from "locales/modules/classForm";
import sessionDetail from "locales/modules/sessionDetail";
import sessionReports from "locales/modules/sessionReports";
import shared from "locales/modules/shared";
import systemAdmin from "locales/modules/systemAdmin";
import users from "locales/modules/users";

export type Language = "vi" | "en";

// Feature modules own their own keys so screens can be translated without
// everyone editing the same two giant files.
const modules: MessageModule<Messages>[] = [
  common,
  attendance,
  classDetail,
  classForm,
  sessionDetail,
  sessionReports,
  shared,
  systemAdmin,
  users,
];

const merge = (base: Messages, lang: Language): Messages => {
  const result: Messages = { ...base };
  for (const mod of modules) {
    for (const [key, value] of Object.entries(mod[lang])) {
      if (process.env.NODE_ENV !== "production" && key in result) {
        console.error(`[i18n] duplicate key "${key}" in ${lang}`);
      }
      result[key] = value;
    }
  }
  return result;
};

export const translations: Record<Language, Messages> = {
  vi: merge(vi, "vi"),
  en: merge(en, "en"),
};

export const LOCALES: Record<Language, string> = { vi: "vi-VN", en: "en-US" };
